module.exports = __webpack_public_path__ + "static/gold_ad-33b5573b94aa2b9eda3f.png";